
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1">
            <div className="flex items-center space-x-3 mb-6">
              <img 
                src="https://public.readdy.ai/ai/img_res/79280e08-340e-4783-bb2b-3e386206d13d.png" 
                alt="QUORUM DOO CACAK Logo" 
                className="h-10 w-10 object-contain"
              />
              <span className="text-xl font-bold">QUORUM</span>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed mb-4">
              Secure your digital freedom with enterprise-grade VPN protection.
            </p>
            <p className="text-gray-300 text-sm leading-relaxed mb-4">
              Protecting your privacy and data with military-grade encryption.
            </p>
            <p className="text-gray-300 text-sm leading-relaxed">
              Trusted by users worldwide for secure internet access.
            </p>
          </div>

          {/* Company Links */}
          <div className="col-span-1">
            <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-6">
              COMPANY
            </h3>
            <ul className="space-y-5">
              <li>
                <Link to="/" className="text-white hover:text-cyan-400 transition-colors duration-300">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/vpn-service" className="text-white hover:text-cyan-400 transition-colors duration-300">
                  VPN Service
                </Link>
              </li>
              <li>
                <Link to="/features" className="text-white hover:text-cyan-400 transition-colors duration-300">
                  Features
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white hover:text-cyan-400 transition-colors duration-300">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div className="col-span-1">
            <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-6">
              LEGAL
            </h3>
            <ul className="space-y-5">
              <li>
                <a href="#privacy" className="text-white hover:text-cyan-400 transition-colors duration-300">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#terms" className="text-white hover:text-cyan-400 transition-colors duration-300">
                  Terms of Service
                </a>
              </li>
              <li>
                <a href="#cookies" className="text-white hover:text-cyan-400 transition-colors duration-300">
                  Cookie Policy
                </a>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div className="col-span-1">
            <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-6">
              CONNECT
            </h3>
            <div className="space-y-4">
              <a 
                href="#linkedin" 
                className="flex items-center justify-center w-10 h-10 bg-white/10 rounded-full text-white hover:bg-cyan-400 hover:text-white transition-all duration-300"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a 
                href="#twitter" 
                className="flex items-center justify-center w-10 h-10 bg-white/10 rounded-full text-white hover:bg-cyan-400 hover:text-white transition-all duration-300"
              >
                <i className="ri-twitter-fill text-lg"></i>
              </a>
              <a 
                href="#facebook" 
                className="flex items-center justify-center w-10 h-10 bg-white/10 rounded-full text-white hover:bg-cyan-400 hover:text-white transition-all duration-300"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-16 pt-8 border-t border-gray-700 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © {currentYear} QUORUM DOO CACAK. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0">
            <a 
              href="https://readdy.ai/?origin=logo" 
              className="text-gray-400 hover:text-cyan-400 text-sm transition-colors duration-300"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
